import { useCollection } from "@/hooks/useCollection";
import { ChartBar, Users2Icon } from "lucide-react";
import React, { useState } from "react";

export default function Admin() {
  const { documents: userDocs } = useCollection("users", null, [
    "plan.purchase_date",
    "desc",
  ]);
  const { documents: progressDocs } = useCollection("progress");

  const [activeTab, setActiveTab] = useState("analytics");
  const [calculationBase, setCalculationBase] = useState("all_users");
  const [filters, setFilters] = useState({
    stage: "all",
  });

  const notUs = (u) =>
    [
      "fkwBohK4VsbkCGWcAqZ2EQ2uz9M2",
      "bUN929XbjjQtHKoFEiP4u8U0APk1",
      "3xBddz9YPaZd7re31wq2Thm1UFF2",
    ].includes(u) === false;

  const getBorderColor = (u) => {
    if (u.lastSeen) {
      if (u.accountNumber) {
        return "border-green-500 bg-green-500/5";
      } else if (progressDocs?.filter((p) => p.userId === u.id).length === 10) {
        return "border-blue-500 bg-blue-500/5";
      } else {
        return "border-input bg-input/5";
      }
    } else {
      return "border-red-500 bg-red-500/5";
    }
  };

  const getCompletedLessons = (userId) => {
    return (
      progressDocs
        ?.filter((p) => p.userId === userId)
        .map((p) => p.lessons)
        .flat().length + "/10"
    );
  };

  const getMeaningfulActions = (actions) => {
    const tags = [];
    if (typeof actions === "undefined") return null;
    if (actions.downloadedSheet) {
      tags.push(<p>Baixou planilha</p>);
    }
    if (actions.accountTutorial?.open.status) {
      tags.push(
        <p className="bg-input border border-input rounded-full w-fit px-1.5 text-xs">
          {"Tutorial de conta: " + actions.accountTutorial?.step || 1}
        </p>
      );
    }
    if (actions.copyTutorial?.open.status === false) {
      tags.push(
        <p>{"Tutorial do copy: " + actions.copyTutorial?.step || 1}</p>
      );
    }

    return tags.map((tag) => <div key={tag}>{tag}</div>);
  };

  const getLoggedInUsers = (base, unit) => {
    if (base === "all_users") {
      base = filteredUserDocs;
    } else if (base === "logged_in") {
      base = filteredUserDocs.filter((u) => u.lastSeen);
    } else if (base === "started_lessons") {
      base = getUsersWhoStartedLessons("all_users", "array");
    } else if (base === "completed_lessons") {
      base = getUsersWhoCompletedLessons("all_users", "array");
    } else if (base === "clicked_affiliate_link") {
      base = getUsersWhoClickedAffiliateLink("all_users", "array");
    } else {
      alert("Error 3");
    }

    const loggedInUsers = base?.filter((u) => u.lastSeen);

    if (unit === "%") {
      if (base?.length === 0) return "0%";
      return `${((loggedInUsers.length / base?.length) * 100).toFixed(2)}%`;
    } else if (unit === "qtt") {
      return loggedInUsers.length;
    } else if (unit === "array") {
      return loggedInUsers;
    } else {
      alert("Error 4");
    }
  };

  const getUsersWhoStartedLessons = (base, unit) => {
    if (base === "all_users") {
      base = filteredUserDocs;
    } else if (base === "started_lessons") {
      base = getUsersWhoStartedLessons("all_users", "array");
    } else if (base === "completed_lessons") {
      base = getUsersWhoCompletedLessons("all_users", "array");
    } else if (base === "logged_in") {
      base = filteredUserDocs.filter((u) => u.lastSeen);
    } else if (base === "clicked_affiliate_link") {
      base = getUsersWhoClickedAffiliateLink("all_users", "array");
    } else {
      alert("Error 5");
    }

    const usersWhoStartedLessons = base?.filter(
      (u) => progressDocs?.filter((p) => p.userId === u.id).length !== 0
    );

    if (unit === "%") {
      if (base?.length === 0) return "0%";
      return `${((usersWhoStartedLessons.length / base?.length) * 100).toFixed(
        2
      )}%`;
    } else if (unit === "qtt") {
      return usersWhoStartedLessons.length;
    } else if (unit === "array") {
      return usersWhoStartedLessons;
    } else {
      alert("Error 6");
    }
  };

  const getUsersWhoCompletedLessons = (base, unit) => {
    // {getUsersWhoCompletedLessons("started_lessons", "%")}

    if (base === "started_lessons") {
      base = getUsersWhoStartedLessons("all_users", "array");
    } else if (base === "all_users") {
      base = filteredUserDocs;
    } else if (base === "clicked_affiliate_link") {
      base = getUsersWhoClickedAffiliateLink("all_users", "array");
    } else if (base === "completed_lessons") {
      base = getUsersWhoCompletedLessons("all_users", "array");
    } else if (base === "started_lessons") {
      base = getUsersWhoStartedLessons("all_users", "array");
    } else if (base === "logged_in") {
      base = filteredUserDocs.filter((u) => u.lastSeen);
    } else {
      alert("Error");
    }

    const usersWhoCompletedLessons = base?.filter(
      (u) => progressDocs?.filter((p) => p.userId === u.id).length === 10
    );

    if (unit === "%") {
      if (base?.length === 0) return "0%";
      return `${(
        (usersWhoCompletedLessons.length / base?.length) *
        100
      ).toFixed(2)}%`;
    } else if (unit === "qtt") {
      return usersWhoCompletedLessons.length;
    } else if (unit === "array") {
      return usersWhoCompletedLessons;
    }

    return `${usersWhoCompletedLessons / base}`;
  };

  const getUsersWhoClickedAffiliateLink = (base, unit) => {
    if (base === "all_users") {
      base = filteredUserDocs;
    } else if (base === "logged_in") {
      base = filteredUserDocs.filter((u) => u.lastSeen);
    } else if (base === "started_lessons") {
      base = getUsersWhoStartedLessons("all_users", "array");
    } else if (base === "completed_lessons") {
      base = getUsersWhoCompletedLessons("all_users", "array");
    } else if (base === "clicked_affiliate_link") {
      base = getUsersWhoClickedAffiliateLink("all_users", "array");
    } else {
      console.log("erro");
    }

    const usersWhoClickedAffiliateLink = base?.filter(
      (u) => u.meaningfulActions?.clickedAffiliateLink?.status
    );

    if (unit === "%") {
      if (base?.length === 0) return "0%";
      return `${(
        (usersWhoClickedAffiliateLink.length / base?.length) *
        100
      ).toFixed(2)}%`;
    } else if (unit === "qtt") {
      return usersWhoClickedAffiliateLink.length;
    } else if (unit === "array") {
      return usersWhoClickedAffiliateLink;
    } else {
      alert("Error 1");
    }
  };

  const getPercentageOfUsersWhoOpenedXMAccount = () => {
    const usersWhoOpenedXMAccount = filteredUserDocs?.filter(
      (u) => typeof u.accountNumber === "string"
    ).length;
    return `${(
      (usersWhoOpenedXMAccount / filteredUserDocs?.length) *
      100
    ).toFixed(2)}%`;
  };

  const getTotalUsers = (base) => {
    if (base === "all_users") {
      return filteredUserDocs?.length;
    } else if (base === "logged_in") {
      return getLoggedInUsers("all_users", "qtt");
    } else if (base === "started_lessons") {
      return getUsersWhoStartedLessons("all_users", "qtt");
    } else if (base === "completed_lessons") {
      return getUsersWhoCompletedLessons("all_users", "qtt");
    } else if (base === "clicked_affiliate_link") {
      return filteredUserDocs?.filter(
        (u) => u.meaningfulActions?.clickedAffiliateLink?.status
      ).length;
    } else {
      alert("Error 2");
    }
  };

  const showData = (data) => {
    if (calculationBase === "all_users") return true;
    if (calculationBase === "logged_in") {
      return data !== "logged_in";
    } else if (calculationBase === "started_lessons") {
      return data !== "logged_in" && data !== "started_lessons";
    } else if (calculationBase === "completed_lessons") {
      return (
        data !== "logged_in" &&
        data !== "started_lessons" &&
        data !== "completed_lessons"
      );
    } else if (calculationBase === "clicked_affiliate_link") {
      return (
        data !== "logged_in" &&
        data !== "started_lessons" &&
        data !== "completed_lessons" &&
        data !== "clicked_affiliate_link"
      );
    }
    return false;
  };

  const labels = [
    { text: "Conta na XM", color: "green-500", value: "xm_account" },
    {
      text: "Completou as aulas",
      color: "blue-500",
      value: "completed_lessons",
    },
    { text: "Já entrou", color: "input", value: "logged_in" },
    { text: "Nunca entrou", color: "red-500", value: "never_logged_in" },
  ];

  const calculationBases = [
    { label: "Todos os usuários", value: "all_users" },
    { label: "Logaram na plataforma", value: "logged_in" },
    { label: "Iniciaram as aulas", value: "started_lessons" },
    { label: "Completaram as aulas", value: "completed_lessons" },
    { label: "Clicaram no link", value: "clicked_affiliate_link" },
  ];

  const filteredUserDocs =
    userDocs
      ?.filter((u) => notUs(u.id))
      .filter((u) => {
        if (filters.stage === "all") return true;
        if (filters.stage === "never_logged_in") return !u.lastSeen;
        if (filters.stage === "xm_account")
          return typeof u.accountNumber === "string";
        if (filters.stage === "completed_lessons") {
          return progressDocs.filter((p) => p.userId === u.id).length === 10;
        }
        if (filters.stage === "logged_in") return u.lastSeen;
      }) || [];

  return (
    <div>
      <div className="bg-blue-500 hidden"></div>
      <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-12">
        <h1 className="font-semibold text-2xl">Painel do admin</h1>
        <div className="flex gap-2.5 flex-wrap">
          <div
            role="button"
            onClick={() => setActiveTab("analytics")}
            className={`h-10 flex items-center text-sm gap-2.5 border p-2.5 rounded-lg ${
              activeTab === "analytics"
                ? "border-icon text-icon font-medium bg-icon/5"
                : "border-input"
            }`}
          >
            <ChartBar className="w-4 h-4" />
            Analytics
          </div>
          <div
            role="button"
            onClick={() => setActiveTab("users")}
            className={`h-10 flex items-center text-sm gap-2.5 border p-2.5 rounded-lg ${
              activeTab === "users"
                ? "border-icon text-icon font-medium bg-icon/5"
                : "border-input"
            }`}
          >
            <Users2Icon className="w-4 h-4" />
            Usuários
          </div>
        </div>
      </div>

      {activeTab === "analytics" && (
        <div className="mt-6 sm:mt-8">
          <div className="flex items-center gap-2.5 text-sm flex-wrap">
            {calculationBases.map((base) => (
              <div
                key={base.value}
                role="button"
                onClick={() => setCalculationBase(base.value)}
                className={`h-8 border border-input flex items-center justify-center p-2.5 rounded-lg ${
                  calculationBase === base.value
                    ? "border-primary text-primary font-medium"
                    : ""
                }`}
              >
                {base.label}
              </div>
            ))}
          </div>
          <div className="mt-5 flex flex-wrap gap-2.5 sm:gap-5 text-sm">
            <div className="flex flex-col items-center gap-2.5 border border-input w-[calc(50%_-_6px)] sm:w-64 py-8 rounded-lg">
              <p>Total de usuários:</p>
              <p className="text-3xl font-medium">
                {getTotalUsers(calculationBase)}
              </p>
            </div>
            {showData("logged_in") && (
              <div className="flex flex-col items-center gap-2.5 border border-input w-[calc(50%_-_6px)] sm:w-64 py-8 rounded-lg">
                <p>Logaram na plataforma:</p>
                <p className="text-3xl font-medium">
                  {getLoggedInUsers(calculationBase, "%")}
                </p>
              </div>
            )}
            {showData("started_lessons") && (
              <div className="flex flex-col items-center gap-2.5 border border-input w-[calc(50%_-_6px)] sm:w-64 py-8 rounded-lg">
                <p>Iniciaram as aulas:</p>
                <p className="text-3xl font-medium">
                  {getUsersWhoStartedLessons(calculationBase, "%")}
                </p>
              </div>
            )}
            {showData("completed_lessons") && (
              <div className="flex flex-col items-center gap-2.5 border border-input w-[calc(50%_-_6px)] sm:w-64 py-8 rounded-lg">
                <p>Completaram as aulas:</p>
                <p className="text-3xl font-medium">
                  {getUsersWhoCompletedLessons(calculationBase, "%")}
                </p>
              </div>
            )}
            {showData("clicked_affiliate_link") && (
              <div className="flex flex-col items-center gap-2.5 border border-input w-[calc(50%_-_6px)] sm:w-64 py-8 rounded-lg">
                <p>Clicaram no link:</p>
                <p className="text-3xl font-medium">
                  {getUsersWhoClickedAffiliateLink(calculationBase, "%")}
                </p>
              </div>
            )}
            <div className="flex flex-col items-center gap-2.5 border border-input w-[calc(50%_-_6px)] sm:w-64 py-8 rounded-lg">
              <p>Abriram conta na XM</p>
              <p className="text-3xl font-medium">
                {getPercentageOfUsersWhoOpenedXMAccount()}
              </p>
            </div>
          </div>
        </div>
      )}
      {activeTab === "users" && (
        <div className="mt-5">
          <div className="mt-1.5 mb-5 flex flex-col sm:flex-row gap-2.5 text-sm">
            <div className="flex items-center gap-3 flex-wrap">
              {labels.map((label) => (
                <div
                  key={label.value}
                  className="flex items-center gap-1"
                  role="button"
                  onClick={() => {
                    if (filters.stage === label.value) {
                      setFilters({ stage: "all" });
                    } else {
                      setFilters({ stage: label.value });
                    }
                  }}
                >
                  <div
                    className={`border border-${label.color} bg-${label.color} w-4 h-4 rounded-full`}
                  ></div>
                  <p>{label.text}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="mt-2.5">
            <div className="flex flex-col flex-wrap gap-2.5 text-sm">
              {filteredUserDocs?.map((userDoc) => (
                <div
                  key={userDoc.id}
                  className={`border-2 ${getBorderColor(
                    userDoc
                  )} sm:w-1/4 p-3 rounded-lg`}
                >
                  <div className="flex justify-between">
                    <p>{userDoc.name}</p>
                    <p className="text-sm">{getCompletedLessons(userDoc.id)}</p>
                  </div>

                  <p className="text-muted-foreground">{userDoc.email}</p>
                  <div className="mt-1.5">
                    {getMeaningfulActions(userDoc.meaningfulActions)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
